import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../../Components/formElements/SearchField";
import InventoryConstants from "../../../../common/InventoryConstants";
import { addStock, getStockList } from "../../../../redux/feature/inventory_app/inventorySlice";
import QrCodePrint from "./QrCodePrint";


const StockList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Stock");
  localStorage.setItem("submenu", "stock-list");
  let stockData = useSelector((state) => state?.inventory?.stock); // User Details from Store
  let stockDataTable = useSelector(
    (state) => state?.inventory?.stock?.pagination
  ); // User Details from Store


  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  const createStock = () => {
    navigate(InventoryConstants.INVENTORY_STOCK_CREATION);
  };
  const detailedPage = (stockNr) => {
    dispatch(addStock(stockNr));
    navigate(InventoryConstants.INVENTORY_STOCK_DETAILS);
  };

  // const Stockdatas = [
  //   {
  //     stockNr: "DOC001",
  //     stockCode: "FG001",
  //     productName: "Cement",
  //     materialName: "Ramco 53",
  //     qty: 100,
  //     stockDescription: "High strength cement",
  //     stockGroup: "RM",
  //     uoM: "Bag",
  //     batchNumber: "BATCH123",
  //     supplierName: "Ramco Ltd",
  //     plantName: "Chennai Plant",
  //   },
  //   {
  //     stockNr: "DOC002",
  //     stockCode: "FG002",
  //     productName: "Steel Rod",
  //     materialName: "TMT 500D",
  //     qty: 200,
  //     stockDescription: "Thermo-Mechanically Treated Rods",
  //     stockGroup: "RM",
  //     uoM: "Ton",
  //     batchNumber: "BATCH456",
  //     supplierName: "Tata Steel",
  //     plantName: "Bangalore Plant",
  //   },
  //   {
  //     stockNr: "DOC003",
  //     stockCode: "FG003",
  //     productName: "Bricks",
  //     materialName: "Fly Ash Brick",
  //     qty: 1500,
  //     stockDescription: "Eco-friendly bricks for construction",
  //     stockGroup: "RM",
  //     uoM: "Piece",
  //     batchNumber: "BATCH789",
  //     supplierName: "ABC Bricks",
  //     plantName: "Hyderabad Plant",
  //   },
  //   {
  //     stockNr: "DOC004",
  //     stockCode: "FG004",
  //     productName: "Sand",
  //     materialName: "River Sand",
  //     qty: 500,
  //     stockDescription: "Washed fine river sand",
  //     stockGroup: "RM",
  //     uoM: "Ton",
  //     batchNumber: "BATCH101",
  //     supplierName: "Natural Resources Pvt Ltd",
  //     plantName: "Coimbatore Plant",
  //   },
  //   {
  //     stockNr: "DOC005",
  //     stockCode: "FG005",
  //     productName: "Concrete",
  //     materialName: "M20 Ready Mix",
  //     qty: 80,
  //     stockDescription: "Ready Mix Concrete M20 Grade",
  //     stockGroup: "FG",
  //     uoM: "Cubic Meter",
  //     batchNumber: "BATCH202",
  //     supplierName: "Ultratech Concrete",
  //     plantName: "Pune Plant",
  //   },
  // ];

  //on page load
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const loadInitialStockData = async () => {
    setData(stockData?.data);
  };
  const [getModalQr, setModalQr] = useState(false);
  const [qrData, setQrData] = useState(null);

  const qrCodeGenerate = (data) => {
    setModalQr(true);
    setQrData(data);
  };

  const hideQrModal = () => {
    setModalQr(false);
  };


  const columns = [
    {
      name: "Document Nr",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.stockNr)}
        >
          {row.stockNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Stock Code",
      selector: (row) => row.stockCode,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.stockCode}</span>
      ),
      width: "130px",
    },
    {
      name: "Product",
      selector: (row) => row.productName,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.productName}</span>
      ),
      width: "130px",
    },
    {
      name: "Generate Qr",
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => qrCodeGenerate(row)}
          >
            Qr
          </button>
        </>
      ),
      width: "120px",
    },
    {
      name: "Material",
      selector: (row) => row.materialName,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.materialName}</span>
      ),
      width: "120px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.quantity}</span>
      ),
      width: "90px",
    },
    {
      name: "Stock Description",
      selector: (row) => row.stockDesc,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.stockDesc}</span>
      ),
      width: "160px",
    },
    {
      name: "Stock Group",
      selector: (row) => row.stockGroup,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.stockGroup}</span>
      ),
      width: "130px",
    },
    {
      name: "UOM",
      selector: (row) => row.uOM,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.uOM}</span>
      ),
      width: "100px",
    },
    {
      name: "Batch Number",
      selector: (row) => row.batchNumber,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 ">{row.batchNumber}</span>
      ),
      width: "160px",
    },
    {
      name: "Supplier",
      selector: (row) => row.supplierName,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1">{row.supplierName}</span>
      ),
      width: "150px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocation,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1">{row.storageLocation}</span>
      ),
      width: "160px",
    },
  ];

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "Get_Stock_Details",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getStockList(obj));
    setData(stockData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getStockList(obj));
    setData(stockData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getStockList(obj));
  };


  const handleSuccessData = async (data) => {
  };
  //on page load
  useEffect(() => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getStockList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialStockData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockData]);
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Stock</h2>
                <p className="subText">Lists of Stock and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Stock List</span>
                      <span className="subHeaderTitle">
                        View of Stock and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/* {config?.createManualPOBtn && ( */}
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => createStock()}
                        >
                          <i className="bi bi-clipboard-check"></i> Create Stock
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={stockData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={stockDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <QrCodePrint
        show={getModalQr}
        onHide={() => hideQrModal()}
        qrInfo={qrData}
        onsuccessdata={handleSuccessData}
      />
    </main>
  );
};
export default StockList;
